import React, { useState } from 'react'
import {
  IconArrowRight,
  IconArrowLeft,
  IconCircleDashed,
  IconCircleCheckFilled,
  IconMinus,
  IconList,
} from '@tabler/icons-react'
import { Link, useLocation, useHistory } from 'react-router-dom'

import { Button } from '@/components/buttons/Button'

import { CHANNEL_NAME, CHANNEL_TYPE } from '@/utils/constants'
import { useShortcut } from '@/utils/hooks/useShortcut'

import './BottomDrawer.scss'

export const PlaylistDrawer = ({ items, currentItemId }) => {
  const [isOpen, setIsOpen] = useState(true)
  const location = useLocation()
  const history = useHistory()
  const queryString = new URLSearchParams(location.search)
  queryString.delete('timestamp')
  queryString.delete('scorecardId')

  // Find the index of the current item (safely)
  if (!items || items.length === 0) return null
  const foundIndex = items.findIndex((item) => item.call_id === Number(currentItemId))
  const currentIndex = foundIndex === -1 ? 0 : foundIndex
  const currentItem = items[currentIndex]

  // Calculate the previous and next indices, wrapping around if necessary
  const prevIndex = (currentIndex - 1 + items.length) % items.length
  const nextIndex = (currentIndex + 1) % items.length
  const toggleDrawer = () => {
    setIsOpen(!isOpen)
  }
  const formatExplorerLink = (item) => {
    return item.record_type === CHANNEL_TYPE.CALL
      ? `/calls/${item.call_id}`
      : `/messages/${item.message_id}`
  }

  const goToPrevItem = () => {
    history.push(`${formatExplorerLink(items[prevIndex])}?${queryString}`)
  }

  const goToNextItem = () => {
    history.push(`${formatExplorerLink(items[nextIndex])}?${queryString}`)
  }

  useShortcut('a', goToPrevItem)
  useShortcut('d', goToNextItem)

  return (
    <div data-testid="playlist-drawer" className={`bottom-drawer ${isOpen ? 'open' : ''}`}>
      <div className="drawer-header">
        <div className="flex-align-center medium-gap">
          <Link
            className="balto-button default"
            to={`${formatExplorerLink(items[prevIndex])}?${queryString}`}
          >
            <IconArrowLeft />
            {`Previous ${CHANNEL_NAME[currentItem.record_type]}`}
          </Link>
          <Link
            className="balto-button default"
            to={`${formatExplorerLink(items[nextIndex])}?${queryString}`}
          >
            {`Next ${CHANNEL_NAME[currentItem.record_type]}`}
            <IconArrowRight />
          </Link>
        </div>
        <Button square onClick={toggleDrawer} data-testid="toggle-drawer">
          {isOpen ? (
            <IconMinus data-testid="minimize-drawer" />
          ) : (
            <IconList data-testid="maximize-drawer" />
          )}
        </Button>
      </div>
      <div className="drawer-content">
        {items.map((item) => (
          <div
            key={item.call_id}
            className={`playlist-drawer-row ${Number(currentItemId) === item.call_id ? 'active' : ''}`}
          >
            <div className="flex-align-center gap">
              <div className="flex-align-center gap">
                {item.is_flagged ? (
                  <IconCircleCheckFilled className="status-success" />
                ) : (
                  <IconCircleDashed className="status-light-muted" />
                )}
              </div>
              <div className="flex-align-center gap">
                <Link to={formatExplorerLink(item)}>
                  {item.alias ||
                    (item.record_type === CHANNEL_TYPE.CALL ? item.call_id : item.message_id)}
                </Link>
              </div>
            </div>
            <div>{item.agent_name}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
